import type { TabSong, TabString } from './types';
/** Original short exercise; the shipped player contains no song transcription. */
export const SAMPLE_TAB: TabSong = {
  id: 'jamcam-first-phrase',
  title: 'First phrase',
  defaultBpm: 80,
  tuning: { name: 'Standard', notes: ['E', 'A', 'D', 'G', 'B', 'E'] },
  sections: [
    { id: 'phrase', name: 'First phrase', startMeasure: 1, endMeasure: 2 },
  ],
  measures: [1, 2].map((number) => ({
    number,
    startBeat: (number - 1) * 4,
    durationBeats: 4,
    timeSignature: { numerator: 4, denominator: 4 },
  })),
  events: [
    [3, 0],
    [3, 2],
    [2, 0],
    [2, 1],
    [2, 3],
    [2, 1],
    [2, 0],
    [3, 2],
  ].map(([string, fret], index) => ({
    id: `note-${index}`,
    type: 'note',
    attack: 'pick',
    startBeat: index,
    durationBeats: 1,
    measure: index < 4 ? 1 : 2,
    notes: [{ string: string as TabString, fret }],
  })),
  source: {
    title: 'JamCam original exercise',
    description:
      'A two-measure exercise for learning the current and next note cues.',
    reviewNotes: [],
  },
};
